const style = { 
    container: {
        paddingTop: "88px",
        backgroundColor: "#000000",
        color: "#FCFCFC",
        width: "100%",
    }
}

export default style;